import { object } from 'prop-types';
import { FormattedMessage } from 'dibs-react-intl';
import { graphql, createFragmentContainer } from 'react-relay';

import { StarRating } from 'dibs-elements/exports/StarRating';

import styles from './PdpSharedStarRating.scss';

function PdpSharedStarRatingComponent({ seller }) {
    const feedbackRatingMean =
        seller?.orderFeedbackPdp?.metadata?.aggregatedFeedback?.overallExperience.mean;
    const feedbackRating = feedbackRatingMean ? parseFloat(feedbackRatingMean.toFixed(1)) : 0;

    return (
        <div className={styles.container}>
            <StarRating rating={feedbackRating} size="small" />
            <div className={styles.fraction}>
                {feedbackRating ? (
                    <FormattedMessage
                        id="PdpSharedStarRating.feedbackRating"
                        defaultMessage={`{feedbackRating, number} / 5`}
                        values={{ feedbackRating }}
                    />
                ) : (
                    <FormattedMessage
                        id="PdpSharedStarRating.noReviews"
                        defaultMessage="No Reviews Yet"
                    />
                )}
            </div>
        </div>
    );
}

PdpSharedStarRatingComponent.propTypes = {
    seller: object,
};

export const PdpSharedStarRating = createFragmentContainer(PdpSharedStarRatingComponent, {
    seller: graphql`
        fragment PdpSharedStarRating_seller on Seller {
            orderFeedbackPdp {
                metadata {
                    aggregatedFeedback {
                        overallExperience {
                            mean
                        }
                    }
                }
            }
        }
    `,
});
